export default __webpack_public_path__ + "static/media/tree.6b729015.png";